module.exports = __webpack_public_path__ + "img/TR.0cd01fad.png";